export default __webpack_public_path__ + "static/media/books-48.65eeff29.jpg";